<nav
  class="flex items-center gap-3 px-4 md:px-6 py-0 bg-pmdf-border-subtle border-b border-pmdf-brand-navy"
  aria-label="Versao do Nexus e status de conexao"
>
  <div class="flex items-center gap-2 flex-1 overflow-hidden text-pmdf-brand-navy font-mono text-sm">
    <span class="font-semibold whitespace-nowrap">Nexus</span>
    <span class="text-pmdf-brand-navy/60">·</span>
    <button
      type="button"
      class="relative flex items-center font-semibold whitespace-nowrap cursor-pointer hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pmdf-brand-navy rounded-sm"
      (click)="abrirNovidades()"
      aria-label="Ver novidades desta versão"
    >
      {{ versionLabel }}
      @if (hasUnread()) {
        <span class="absolute -top-1 -right-2 w-1.5 h-1.5 rounded-full bg-pmdf-danger"></span>
      }
    </button>
  </div>

  <span class="text-pmdf-brand-navy">|</span>

  <div class="flex items-center gap-2">
    @if (isOffline()) {
      <mat-icon class="icon-sm animate-pulse text-pmdf-warning">cloud_off</mat-icon>
      <span class="font-semibold text-sm">Offline</span>
    } @else {
      <mat-icon class="icon-sm text-pmdf-success">cloud_done</mat-icon>
      <span class="font-semibold text-sm text-pmdf-success font-mono">Online</span>
    }
  </div>
</nav>
